<template>
  <a-form-item
    :label="label"
    :name="name"
    :rules="rules || [{ required: true, message: `请输入${label}` }]"
    class="form-item"
  >
    <a-input-password
      :value="modelValue"
      @update:value="$emit('update:modelValue', $event)"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :size="size"
      class="form-input"
    />
  </a-form-item>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: "密码",
  },
  name: {
    type: String,
    required: true,
  },
  placeholder: {
    type: String,
    default: "请输入密码",
  },
  autocomplete: {
    type: String,
    default: "current-password",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: "middle",
  },
  rules: {
    type: Array,
    default: null,
  },
});

defineEmits(["update:modelValue"]);
</script>

<style scoped lang="less">
.form-item {
  margin-bottom: 24px;

  :deep(.ant-form-item-label) {
    padding-bottom: 8px;

    label {
      color: @grey-65;
      font-size: @font-size-base;
      height: 22px;
    }
  }

  .form-input {
    :deep(.ant-input-affix-wrapper) {
      padding: 8px 11px;
      height: 44px;
      border-radius: 6px;
      border: 1px solid @grey-15;
      transition: all 0.3s ease;

      &:hover {
        border-color: @primary-5;
      }

      &:focus,
      &-focused {
        border-color: @primary-color;
        box-shadow: 0 0 0 2px fade(@primary-color, 20%);
      }

      .ant-input-prefix {
        margin-right: 12px;

        .anticon {
          color: @grey-45;
          font-size: 18px;
        }
      }

      .ant-input {
        font-size: @font-size-base;

        &::placeholder {
          color: @grey-25;
        }
      }
    }

    &.ant-input-disabled {
      background-color: @grey-4;
      cursor: not-allowed;

      .ant-input-prefix .anticon {
        color: @grey-25;
      }
    }
  }
}
</style>
